import React, { Component } from "react";
import { BrowserRouter, Link, Route, Switch } from "react-router-dom";
import Bounty from "./components/Bounty";
import Homepage from "./components/Homepage";
import PostBounty from "./components/PostBounty";
import Profile from "./components/Profile";
import Auth from "./components/Auth";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: window.location.pathname,
      prevPage: "/",
      hiddenTabBar: false
    };
  }

  updatePage = page => {
    this.setState(prevState => ({
      currentPage: page,
      prevPage: prevState.currentPage
    }));
  };

  setTabBar = config => {
    this.setState({
      hiddenTabBar: config
    });
  };

  render() {
    const { currentPage, hiddenTabBar, prevPage } = this.state;

    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={props => <Homepage {...props} setPage={this.updatePage} />}
          />
          <Route
            exact
            path="/post"
            render={props => (
              <PostBounty
                {...props}
                toggleTab={this.setTabBar}
                setPage={this.updatePage}
                setTitle={this.updateTaskBarTitle}
                prevPath={prevPage}
              />
            )}
          />
          <Route
            exact
            path="/bounty"
            render={props => (
              <Bounty
                {...props}
                setPage={this.updatePage}
                setTitle={this.updateTaskBarTitle}
                prevPath={prevPage}
              />
            )}
          />
          <Route exact path="/auth" component={Auth} />
          <Route exact path="/profile" component={Profile} />
        </Switch>

        <div className="tab-navigator shadowed">
          <Link
            className="tab-navigator-button"
            to={{ pathname: "/" }}
            onClick={() => this.setState({ currentPage: "/" })}
          >
            <i
              className={`tab-button-icon fas fa-home ${
                currentPage === "/" ? "active" : ""
              }`}
            />
          </Link>
          <Link
            className="tab-navigator-button"
            to={{ pathname: "/post" }}
            onClick={() => this.setState({ currentPage: "/post" })}
          >
            <i
              className={`tab-button-icon fas fa-camera ${
                currentPage === "/post" ? "active" : ""
              }`}
            />
          </Link>
          <Link
            className="tab-navigator-button"
            to={{ pathname: "/profile" }}
            onClick={() => this.setState({ currentPage: "/profile" })}
          >
            <i
              className={`tab-button-icon fas fa-user ${
                currentPage === "/profile" ? "active" : ""
              }`}
            />
          </Link>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
